package co.maytes.standupbot.dashboard.components.feedback

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.widgets.Button
import co.maytes.standupbot.dashboard.components.widgets.ButtonVariant
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Radius
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText

/**
 * Compact error-toned card with an optional Retry action. Suitable for inline
 * fetch failures (list + detail). Uses the error palette for the border/accent
 * and keeps the body on a light surface so the copy stays readable.
 */
@Composable
fun ErrorState(
    title: String = "Something went wrong",
    message: String,
    retryLabel: String? = "Retry",
    onRetry: (() -> Unit)? = null,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(Spacing.lg)
            .borderRadius(Radius.md)
            .styleModifier {
                property("background", "rgba(239, 68, 68, 0.06)")
                property("border", "1px solid rgba(239, 68, 68, 0.35)")
            },
    ) {
        SpanText(
            text = title,
            modifier = Modifier
                .fontSize(Typography.body.size)
                .fontWeight(600)
                .color(Palette.error),
        )
        SpanText(
            text = message,
            modifier = Modifier
                .margin(top = Spacing.xs)
                .fontSize(Typography.bodySmall.size)
                .color(Palette.textSecondary),
        )
        if (retryLabel != null && onRetry != null) {
            com.varabyte.kobweb.compose.foundation.layout.Box(
                modifier = Modifier.margin(top = Spacing.md),
            ) {
                Button(label = retryLabel, variant = ButtonVariant.Secondary, onClick = onRetry)
            }
        }
    }
}
